const styles = (theme) => ({
  containerPaper: {
    backgroundColor: theme.palette.background.paper,
    padding: "20px",
    borderRadius: "16px",
    display: "flex",
    flexDirection: "column",
  },
  containerActions: {
    display: "flex",
    flexWrap: "wrap",
    gap: 2,
    width: "100%",
  },
  chipPago: {
    backgroundColor: theme.palette.chip.background.success,
    color: theme.palette.chip.colorText.success,
    border: "0.6px solid ",
    borderColor: theme.palette.chip.colorText.success,
    borderRadius: "10px",
    height: "20px",
    width: "120px",
  },
  boxLine: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    background:
      theme.palette.mode === "dark"
        ? theme.palette.background.modalContrast
        : theme.palette.colors.white.light,
    borderRadius: "6px",
    p: 1,
  },
  chipRenegociado: {
    backgroundColor: theme.palette.chip.background.medium,
    color: theme.palette.chip.colorText.medium,
    border: "0.6px solid ",
    borderColor: theme.palette.chip.colorText.medium,
    borderRadius: "10px",
    height: "20px",
    width: "120px",
  },
  chipCancelado: {
    backgroundColor: theme.palette.chip.background.info,
    color: theme.palette.white.main,
    border: `0.6px solid ${theme.palette.chip.colorText.default}`,
    borderColor: theme.palette.chip.colorText.info,
    borderRadius: "10px",
    height: "20px",
    width: "120px",
  },
  chipAguardando: {
    backgroundColor: theme.palette.chip.background.high,
    color: theme.palette.chip.colorText.high,
    border: "0.6px solid ",
    borderColor: theme.palette.colors.orange.medium,
    borderRadius: "10px",
    height: "20px",
    width: "120px",
  },
  chipVencido: {
    backgroundColor: theme.palette.chip.background.critical,
    color: theme.palette.chip.colorText.critical,
    border: "0.1px solid ",
    borderColor:
      theme.palette.mode === "dark"
        ? theme.palette.colors.red.darker
        : theme.palette.colors.red.light,
    borderRadius: "10px",
    height: "20px",
    width: "120px",
  },
});

export default styles;
